module.exports = __webpack_public_path__ + "img/it_seguromovil.4b3818cf.svg";